__turbopack_context__.v({
  "infoFrame": "_9OvziW_infoFrame",
  "itemsWrapper": "_9OvziW_itemsWrapper",
  "title": "_9OvziW_title",
  "wrapper": "_9OvziW_wrapper",
});
